<template>
    <div class="ma-4">
      <delete-note-dialog
        ref="dialog"
        title="Removing..."
        @openDialog="archiveInventory"
        @on-submit="inventoryArchive"
      />
      <v-snackbar v-model="msg" top>
        {{ text }}
        <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
      >
      <StaffNav class="hideOnPrint" />
      <v-row dense class="hideOnPrint">
        <v-col cols="12" lg="3" xl="2">
          <StaffSide />
        </v-col>
        <v-col cols="12" lg="9" xl="10">
          <v-card class="pa-2" outlined tile height="100%">
            <v-tabs v-model="tab">
              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab v-for="(item, index) in items" :key="index">
                {{ item }}
                <v-chip class="ml-2" color="green" text-color="white" small>
                    {{ index === 0 ? activeInventory : discontinued }}
                </v-chip>
              </v-tab>
            </v-tabs>
  
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="(item, i) in items" :key="item">
                <v-card class="pa-2" outlined tile height="100%">
                  <template>
                    <v-data-table
                      :headers="i === 0 ? headers : discontinuedHeader"
                      :items="i === 0 ? inventories : discontinuedInventories"
                      sort-by="DateAdded"
                      sort-desc
                      :loading="isLoading"
                      loading-text="Loading Inventory"
                      :search="search"
                      height="550"
                    >
                      <template v-slot:top>
                        <v-toolbar flat color="white">
                          <v-toolbar-title>{{
                            i === 0 ? "Inventory" : "Discountinued Inventory"
                          }}</v-toolbar-title>
                          <v-divider class="mx-4" inset vertical></v-divider>
                          <v-spacer></v-spacer>
                          <v-text-field
                            v-model="search"
                            clearable
                            flat
                            solo-inverted
                            hide-details
                            prepend-inner-icon="search"
                            label="search"
                            class="desktop"
                          ></v-text-field>                         

                          <v-spacer></v-spacer>
                          <report-list-actions
                            :reportOptions="reportOptions"
                            :downloadFilename="reportListFilename"
                          ></report-list-actions>

                          <v-dialog v-model="dialog" max-width="100%">
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-if="i === 0 && !isAuditorRole"
                                color="#2b3990"
                                dark
                                class="mb-2"
                                v-on="on"
                                @click="showAdd()"
                              >
                                <v-icon left>add</v-icon>
                                Add Inventory</v-btn
                              >
                            </template>
                            <v-card>
                              <v-card-title style="background-color: #2b3990">
                                <span class="headline white--text">{{
                                  titleForm
                                }}</span>
                              </v-card-title>
                              <v-card-text>
                                <v-container>
                                  <v-row>
                                    <v-col cols="12" sm="12" md="4">
                                      <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-text-field
                                            v-model="newDateAdded"
                                            label="Date Added"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            clearable
                                          ></v-text-field>
                                        </template>
                                        <v-date-picker
                                          v-model="newDateAdded"
                                          no-title
                                          scrollable
                                        >
                                        </v-date-picker>
                                      </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="4">
                                      <v-text-field
                                        label="Item Name"
                                        v-model="newItem"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="6" sm="6" md="4">
                                      <v-text-field
                                        label="Value of Item"
                                        v-model="newValue"
                                        prefix="$"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                      <v-textarea
                                        v-model="newDescription"
                                        label="Item Description"
                                        outlined
                                      ></v-textarea>
                                    </v-col>
                                    <v-col
                                      class="d-flex"
                                      cols="12"
                                      sm="12"
                                      md="6"
                                    >
                                      <v-file-input
                                        v-model="newImage"
                                        class="pa-2"
                                        label="New Image"
                                        show-size
                                        filled
                                        multiple
                                        prepend-icon="mdi-camera"
                                        accept="image/*"
                                        @change="imgSelected"
                                      >
                                        <template #selection="{ text, index }">
                                          <v-chip
                                            small
                                            label
                                            close
                                            color="primary"
                                            @click:close="deleteChip(index)"
                                            >{{ text }}</v-chip
                                          >
                                        </template>
                                      </v-file-input>
                                    </v-col>
                                    <v-carousel>
                                      <template
                                        v-for="(item, index) in imageDetails"
                                      >
                                        <v-carousel-item :key="index">
                                          <v-row
                                            class="flex-nowrap"
                                            style="height: 100%"
                                          >
                                            <v-img :src="item.AWSLink">
                                              <v-row
                                                class="fill-height"
                                                align="center"
                                                justify="center"
                                              >
                                                <div
                                                  style="
                                                    color: #000;
                                                    padding-top: 30%;
                                                  "
                                                >
                                                  {{ item.Name }}
                                                </div>
                                              </v-row>
                                            </v-img>
                                          </v-row>
                                        </v-carousel-item>
                                      </template>
                                      <!--
                                <v-carousel-item
                                  v-for="(item,i) in imageDetails"
                                  :key="i"
                                >
                                  <v-img :src="item.AWSLink"></v-img>
                                </v-carousel-item>
                                -->
                                    </v-carousel>
                                    <!-- <v-col class="d-flex" cols="12" sm="12">
                                <template >
                                  <v-img
                                    :src="newImageLink"
                                    height="200px;"
                                  ></v-img>
                                </template>
                              </v-col> -->
                                    <v-col class="d-flex" cols="12" sm="12">
                                      <v-text-field
                                        v-model="newEnteredBy"
                                        label="Entered By"
                                        readonly
                                        @click="addSignature"
                                      ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                      <!-- <v-text-field
                                  v-model="newClientSignature"
                                  label="Client Signature"
                                ></v-text-field>-->
                                      <div class="ma-5">
                                        <v-img
                                          v-if="digitalSignature"
                                          max-height="80"
                                          max-width="150"
                                          :src="digitalSignature"
                                        ></v-img>
                                      </div>
                                      <v-btn
                                        class="white--text"
                                        color="#2b3990"
                                        @click="showSignaturePad = true"
                                        >Staff Signature</v-btn
                                      >
                                      <SignaturePad
                                        :showSignaturePad="showSignaturePad"
                                        @close="showSignaturePad = false"
                                        @signatureData="signatureData"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
  
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  class="white--text"
                                  color="#259647"
                                  @click="addInventory()"
                                  v-if="newInventory"
                                >
                                  Save
                                </v-btn>
                                <v-btn
                                  fab
                                  small
                                  @click="printItem()"
                                  class="mr-8 mb-2 white--text"
                                  color="#2b6993"
                                  elevation="4"
                                  v-if="editInventory"
                                >
                                  <v-icon>print</v-icon>
                                </v-btn>
                                <v-btn
                                  color="primary"
                                  @click="updateInventory()"
                                  v-if="editInventory"
                                >
                                  Update
                                </v-btn>
                                <v-btn color="blue darken-1" text @click="close"
                                  >Cancel</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-toolbar>
                        <v-text-field
                          v-model="search"
                          clearable
                          flat
                          solo-inverted
                          hide-details
                          prepend-inner-icon="search"
                          label="search"
                          class="mobile ml-5 mr-5 mb-3 mt-3"
                        ></v-text-field>
                      </template>
  
                      <template v-slot:item.actions="{ item }">
                        <v-icon small class="mr-2" @click="viewInventory(item)">
                          mdi-eye
                        </v-icon>
                        <!-- <v-icon small class="mr-2" @click="editInventory(item)">
                    mdi-pencil
                  </v-icon> -->
                        <!-- <v-icon small class="mr-2" @click="deleteInventory(item)" v-if="canDelete">
                    mdi-delete
                  </v-icon> -->
  
                        <v-icon
                          small
                          @click="archiveInventory(item)"
                          v-if="canDelete && i === 0 && !isAuditorRole"
                        >
                          mdi-trash-can
                        </v-icon>
  
                        <!-- <v-icon small @click="addDeal(item)">
                    add
                  </v-icon> -->
                      </template>
                      <template v-slot:no-data>
                        <v-btn
                          color="#2b3990"
                          class="white--text"
                          @click="getInventories()"
                          >Reset</v-btn
                        >
                      </template>
                    </v-data-table>
                  </template>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
      <Foot class="hideOnPrint" />
  
    </div>
  </template>
  
  <script>
  
  /*eslint-disable */
  import axios from "axios";
  import StaffNav from "@/components/StaffNav";
  import StaffSide from "@/components/StaffSide";
  import Foot from "@/components/Footer";
  import moment from "moment";
  import DeleteNoteDialog from "@/components/shared/DeleteNoteDialog.vue";
  // import LoadPDF from '../../components/LoadPDF.vue'
  import SignaturePad from "@/components/SignaturePad";  
  import ReportListActions from '@/components/Report/ReportListActions.vue'
  
  import { mapActions } from "vuex";
  
  const url = require("../client_config/config").url;
  
  export default {
    components: {
      StaffNav,
      StaffSide,
      DeleteNoteDialog,
      SignaturePad,
      Foot,
      ReportListActions
    },
    data: function () {
      return {
        headers: [
          {
            text: "Date Added",
            align: "start",
            sortable: true,
            value: "DateAdded",
          },
          { text: "Description", value: "Description" },
          { text: "Value", value: "Value" },
          { text: "EnteredBy", value: "EnteredBy" },
          { text: "Actions", value: "actions", sortable: false },
        ],
  
        discontinuedHeader: [
          {
            text: "Date Removed",
            align: "start",
            sortable: true,
            value: "deletedAt",
          },
          { text: "Description", value: "Description" },
          { text: "Value", value: "Value" },
          { text: "EnteredBy", value: "EnteredBy" },
          { text: "RemovedBy", value: "updatedBy" },
          { text: "Reason", value: "Reason" },
          { text: "Actions", value: "actions", sortable: false },
        ],
        items: ["Inventory", "Discountinued Inventory"],
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        menu: false,
        menu2: false,
        dialog: false,
        editInventory: false,
        newInventory: false,
        msg: false,
        search: "",
        text: "",
        inventories: [],
        tempData: [],
        users: [],
        staff: "",
        staffID: this.$route.params.employeeID,
        userID: localStorage.getItem("userID"),
        titleForm: "New Inventory Item",
        inventoryID: "",
        newDateAdded: "",
        newValue: "",
        newDescription: "",
        newImage: [],
        imageDetails: [],
        newImageLink: "",
        newEnteredBy: "",
        newStaffSignature: "",
        inventorySignaturepad: false,
        newItem: "",
        canDelete: false,
        directCare: false,
        editedIndex: -1,
        editedItem: {
          dateAdded: "",
          description: "",
          value: "",
          image: "",
          enteredBy: "",
          clientSignature: "",
          item: "",
        },
        defaultItem: {
          dateAdded: "",
          description: "",
          value: "",
          image: "",
          enteredBy: "",
          clientSignature: "",
          item: "",
        },
        isLoading: true,
        uploadImg: "",
        tab: null,
        discontinuedInventories: [],
        tempDataInventories: [],
        showSignaturePad: false,
        digitalSignature: "",
      };
    },
  
    computed: {
      formTitle() {
        return this.editedIndex != 1 ? "New Item" : "Edit Item";
      },
      clientName() {
        // `this` points to the component instance
        return this.$store.state.clients.client.Name;
      },

      activeInventory() {
          return this.inventories.length;
      },
      discontinued() {
          return this.discontinuedInventories.length;
      },

      staffName() {
        return this.$store.state.users.user.Name;
      },

      selectedEmployee() {
        return this.$store.state.users.allUsers.find(
            (user) => user._id == this.staffID
        )
      },

      employeeName() {
         return this.selectedEmployee?.Name || this.staffName
      }, 
    
      reportOptions() {
        return { 
          query: {
            name: this.employeeName,
          },
          endpoints: `staffInventory/printList/${this.staffID}`,
          dynamic: true
        }
      },
      reportListFilename() {
        return `${this.employeeName} - Staff Inventory`
      },
      isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
      }
    },
  
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
  
    created() {
      this.getInventories();
      this.getUsers();
    //   this.getStaffInfo(this.staffID);
      if (
        localStorage.getItem("userRole") == "Administration" ||
        localStorage.getItem("userRole") == "Client Services Manager" ||
        localStorage.getItem("userRole") == "Program Coordinator" ||
        localStorage.getItem("userRole") == "Human Resources" ||
        localStorage.getItem("userRole") == "Compliance Manager"
      ) {
        this.canDelete = true;
      } else {
        this.canDelete = false;
      }
      if (localStorage.getItem("userRole") == "Direct Care Staff") {
        this.directCare = true;
      }
    },
  
    methods: {
    //   ...mapActions({
    //     getClientInfo: "clients/getClient",
    //   }),
      initialize() {
        this.inventories = [];
      },
      viewInventory(item) {
        this.titleForm = "Viewing " + item.Item;
        this.dialog = true;
        this.editInventory = true;
        this.newInventory = false;
        this.newDateAdded = item.DateAdded;
        this.newDescription = item.Description;
        this.newItem = item.Item;
        this.newValue = item.Value;
  
        if (item.documents.length > 0) {
          const tempData = [];
          for (let i = 0; i < item.documents.length; i++) {
            let fileExt = item.documents[i].AWSLink.split(".").pop();
            tempData.push({
              name: item.documents[i].Name,
              ext: fileExt,
              id: item.documents[i]._id,
              awsLink: item.documents[i].AWSLink,
            });
          }
          this.newImage = tempData;
          this.newImageLink = this.newImage[0].awsLink;
        }
  
        this.imageDetails = item.documents;
  
        this.newEnteredBy = item.EnteredBy;
        this.digitalSignature = item.StaffSignature;
        this.inventoryID = item._id;
        console.log(item)
      },
      showAdd() {
        this.titleForm = "New Inventory Item";
        this.newInventory = true;
        this.editInventory = false;
      },
  
      archiveInventory(item) {
        this.inventoryID = item._id;
        this.$refs.dialog.openDialog();
      },
  
      async inventoryArchive(note) {
        try {
          const response = await axios.put(`${url}/staffInventory/archive/${this.inventoryID}`, {
            reason: note,
            deletedAt: new Date(),
          });
          if (response.status === 200) {
            this.$refs.dialog.openDialog();
            this.getInventories();
            this.msg = true;
            this.text = "The inventory item has been deleted successfully.";
          }
        } catch (error) {
          console.log(error)
          const errorMessage = error.response?.data?.message || "An error occurred while archiving the inventory";
          this.msg = false;
          this.text = errorMessage;
          this.$refs.dialog.openDialog();
        }
      },
  
      clear() {
        this.newDateAdded = moment(new Date()).format("YYYY-MM-DD");
        this.newDescription = "";
        this.newImage = [];
        this.newValue = "";
        this.newEnteredBy = "";
        this.newStaffSignature = "";
        this.newImageLink = "";
        this.newItem = "";
        this.digitalSignature = ""
      },
  
      close() {
        this.dialog = false;
        this.clear();
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
  
      updateInventory() {
        var req_body = {
          DateAdded: this.newDateAdded,
          Description: this.newDescription,
          Value: this.newValue,
          //Image: this.newImage,
          EnteredBy: this.newEnteredBy,
          StaffSignature: this.digitalSignature,
          Item: this.newItem,
          deletedAt: new Date(),
        };
        axios
          .put(`${url}/staffInventory/${this.inventoryID}`, req_body)
          .then((response) => {
            this.getInventories();
            if (response.status == 400) {
              response.json().then(function (data) {
                alert(data.msg);
              });
            }
            this.msg = true;
            this.text = "The inventory Item has been updated successfully.";
            this.saveImg();
          });
        this.close();
      },
  
      getInventories: function () {
        this.isLoading = true;
        axios
          .get(`${url}/staffInventory/staff/${this.staffID}`)
          .then((res) => {
            this.discontinuedInventories = [];
            this.inventories = [];
            this.tempDataInventories = res.data.inventories;
  
            this.inventories = this.tempDataInventories.filter(
              (item) => item.isDeleted === false || item.isDeleted === undefined
            ).map((item)=> {
              return {
                ...item,
                DateAdded: this.dateCheck(item.DateAdded, "YYYY-MM-DD")
              }
            })
  
            this.discontinuedInventories = this.tempDataInventories
              .filter((item) => item.isDeleted === true)
              .map((date) => {
                if (!date.hasOwnProperty("deletedAt")) {
                  return Object.assign({}, date, {
                    deletedAt: date.hasOwnProperty("updatedAt")
                      ? date.updatedAt
                      : null,
                  });
                } else {
                  return date;
                }
              }).map(item => {
                return {
                  ...item,
                  deletedAt: this.dateCheck(item.deletedAt, "YYYY-MM-DD")
                }
              });
          })
          .finally(() => (this.isLoading = false));
      },
  
      addInventory: function () {
        var req_body = {
          DateAdded: this.newDateAdded,
          Description: this.newDescription,
          Value: this.newValue,
          EnteredBy: this.newEnteredBy,
          StaffSignature: this.digitalSignature,
          StaffID: this.staffID,
          Item: this.newItem,
        };
  
        axios.post(`${url}/staffInventory`, req_body).then((res) => {
          this.getInventories();
          if (res.status == 400) {
            res.json().then(function (data) {
              this.text = data.msg;
            });
          }
  
          this.msg = true;
          this.text = "The new inventory item has been added successfully.";
          this.inventoryID = res.data._id;
          this.saveImg();
        });
        this.close();
      },
  
      getUsers: function () {
        axios.get(`${url}/users`).then(async (res) => {
          this.users = res.data.users;
          for (var i = 0; i < this.users.length; i++) {
            if (this.userID == this.users[i]._id) {
              this.staff = this.users[i].Name;
            }
          }
          this.newEnteredBy = this.staff + " - " + new Date();
        });
      },
  
      imgSelected(e) {
        this.uploadImg = e;
      },
  
      saveImg() {
        this.message = "";
        for (let i = 0; i < this.uploadImg.length; i++) {
          this.uploadFiles(this.uploadImg[i]);
        }
      },
  
      uploadFiles(file) {
        const formData = new FormData();
        formData.append("inventory-img", file);
        var ct = { headers: { "content-type": "multipart/form-data" } };
        axios
          .post(`${url}/Inventory/imguploader/${this.inventoryID}`, formData, ct)
          .then((res) => {
            if (res) {
              this.getInventories();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
  
      addSignature() {
        this.newEnteredBy = this.staff + " - " + new Date();
      },
  
      signatureData(data) {
        this.digitalSignature = data;
      },
  
      deleteChip(index) {
        // Prompt here with text if required
        this.newImage.splice(index, 1);
      },
  
      printItem() {
        document.getElementById("printItem").style.display = "block";
        document.getElementsByClassName('v-overlay__scrim')[0].style.backgroundColor = "transparent";      
  
        window.print();
      },
  
      dateCheck(date, format) {
        return date !== "Invalid date" && date !== ""
          ? moment(String(date)).format(format)
          : "";
      },
    },
  };
  </script>
  <style>
  @media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }
  }
  
  #printItem {
    display: none;
  }
  
  @media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }
  }
  
  @media print {
    #printItem {
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
    }
    .hideOnPrint {
      display: none;
      border: none;
    }
  
    nav.v-navigation-drawer,
    header.v-toolbar,
    button.v-btn,
    div.v-card {
      display: none;
      border: none;
    }
  
    @page {
      margin: 0;
    }
    body {
      margin: 1.6cm;
    }
  }
  
  </style>
  